import { createApp } from 'vue';  // Importing the createApp function from Vue 3
import { createStore } from 'vuex';  // Import the createStore function from Vuex
import modules from './modules';    // Import the Vuex modules

// Create the Vuex store instance
const store = createStore({
  modules,
  strict: process.env.VUE_APP_NODE_ENV === 'development',  // Enables strict mode in development
});

// Create the Vue app instance
const app = createApp({});

// Use the store in the app instance
app.use(store);

export default store;
